module.exports = __webpack_public_path__ + "static/media/42import-76.d56de25a.xlsx";